import { NgModule } from '@angular/core';
import { Route, RouterModule, Router } from '@angular/router';
import { RoleGuard } from '../roles/role.guard';
import { RouteService } from '../services/route.service';
import { SampleModule } from './sample/sample.module';

@NgModule({
  imports: [SampleModule],
  exports: [RouterModule]
})
export class PbiRoutingModule {
    constructor(private router: Router, private routeService: RouteService) {
        this.routeService.getPbiRoutes()
        .then(routes => {
            const safeChildren = Array.isArray(routes) ? routes.filter(Boolean) : [];
            // Se não há rotas válidas, não injeta config (evita quebrar o Router inteiro)
            if (safeChildren.length === 0) return;
            let route: Route = {
                path: '',
                children: safeChildren,
                canActivateChild: [RoleGuard],
            };
            this.router.config.unshift(route);
            this.router.resetConfig(this.router.config);
        })
        .catch(e => console.log('e', e));
    }
}
